<template>
    <div id="app">
        <navigation/>

        <div class="ml20">
            <div class="borderB1_dc mt50 pb80">
                <p class="ft40 li_h40  ft-weight">订单提交成功！请尽快完成付款</p>
                <p class="mt30  ft30 ">
                    购买{{dataPackage!=null?dataPackage.title:''}},<span class="color_e53817">{{dataPackage!=null?dataPackage.num:''}}</span>次备案次数 
                    <span class="color_0">总计支付金额：</span>
                    <span class="color_e53817">{{dataPackage!=null?dataPackage.price:''}}元</span>
                </p>
               
                <p class="ft26 color_0 mb30 ft-weight">使用快捷支付</p>
                <div class="cheackBody">

                    <div style="float:left">
                        <el-radio v-model="radio1" label="1"  @change="selectPayType(1)" border>微信支付</el-radio>
                        <el-radio v-model="radio1" label="2"  @change="selectPayType(2)" border>银行卡支付</el-radio>
                    </div>

                    <div class="ar">
                            <p style="color:green;margin-left:30px" v-if='radio1 == 1'>请扫码进行支付</p>
                            <img class="img" :src="wxPayUrl" v-if="wxPayUrl!='' && radio1 == 1" />
                        <div v-if="radio1 == 2">
                            <p class="ft26 color_0 mb10 ft-weight">使用银行卡支付,请转到下面银行账户</p>
							<p class="ft26 color_0 mb30">(转账后需平台确认，请耐心等待)</p>
							<ul class="bankCard_details_vessel">
								<li>公司名称：深圳市求实知识产权科技有限公司</li>
								<li>统一社会信用代码：914403005956528917</li>
								<li>开户银行：中国工商银行深圳市华侨城支行</li>
								<li>开户账号：40000 2323 9200 1432 88</li>
								<li>开户行地址：深圳市南山区华侨城光华街22栋</li>
                                <li style="color:red">备注：转帐时请注明平台注册手机号</li>
							</ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navigation from '@/components/area/Navigation.vue'
import {orderCheckFApi} from '@/service/allApi'
export default {
    data(){
        return{
            dataPackage:null,
            radio1:'1' ,
            wxPayUrl:'', // 微信支付二维码
            orderNo:'',
            a:null
        }
    },
    created(){
        var dataPackage = JSON.parse(localStorage.getItem("dataPackage"));
        // console.log(dataPackage.title)

        this.dataPackage = dataPackage;

         var orderNo =  localStorage.getItem("orderNo");
         if(orderNo!=null){
             this.orderNo = orderNo
             this.wxPayUrl='/api/order/wechat_pay?orderNo='+orderNo+'&description='+2
             this.orderCheckF()
         }
    },
    methods:{
        //微信监测支付情况
          orderCheckF(){
            var that = this
            that.a = setInterval(function () {
                var data = {
                    orderno:that.orderNo
                }
                that.orderCheckFAp(data)
            }, 2000)
        },

       async orderCheckFAp(data){
        //    var that = this
            const res = await orderCheckFApi(data) 
             if(res.data!=undefined){
                if(res.data.code == 100){
                    clearInterval(this.a)
                    this.$message({
                        message: '恭喜你，支付成功',
                        type: 'success'
                    });
                    setTimeout(function(){
                        window.history.go(-1)
                    },3000)
                }
            }
        },
        //选择支付方式
        selectPayType(id){
            if(id==1){
                if(this.orderNo!=null){
                    // this.orderNo = orderNo
                    this.wxPayUrl='/api/order/wechat_pay?orderNo='+this.orderNo+'&description='+2
                    this.orderCheckF()
                }
            }else{
                clearInterval(this.a)
            }
        }
    },
     components: {
        navigation: Navigation
    }
}
</script>


<style scoped>
.ml20{
    margin-left :40px;
}
.ft40{
    font-size: 40px;
}
.li_h40{
    line-height: 40px;
}
.ft-weight{
    font-weight: bold;
}

.color_0{
    color: rgb(0, 0, 0);
}

.color_e53817{
    color: #e53817;
}

.li_h30{
    line-height: 30px;
}

.mt30{
    margin-top: 30px;
}
.ft36{
    font-size: 36px;
}
.mt50{
    margin-top: 50px;
}
.ft30{
    font-size: 30px;
}
.pb80{
    padding-bottom: 80px;
}

.cheackBody{
    width: 60%;
    height: 300px;
    border: 1px solid red;
    padding: 30px;
}

.ar{
    float: left;
    margin-left: 330px;
}

.img{
    float: left;
    width: 200px;
    height: 200px;
    border: 1px solid green;
    margin-left: -23px;
}

</style>


// WEBPACK FOOTER //
// src/components/pay.vue